import { competeScore, competitiveBasis } from "../../lib/competitiveSort";

// The "Most competitive first" sort number, shown first so the visible value matches the order.
export function CompeteChip({ r, testId }) {
  const score = competeScore(r);
  if (score == null) {
    return (
      <span data-testid={`${testId}-none`} title="No entry tariff or acceptance rate on file, so this course goes to the bottom of this sort."
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-stone-100 border border-stone-300 text-stone-600 text-[11px]">
        Ranking — not sourced
      </span>
    );
  }
  return (
    <span data-testid={testId} title={`The number this list is sorted by. Based on ${competitiveBasis(r)}. Not your personal chance or a league-table position.`}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-indigo-50 border border-indigo-300 text-indigo-800 text-[11px]">
      Compete&nbsp;<span className="font-mono font-semibold">{Math.round(score * 100)}</span>
    </span>
  );
}
